module.exports = __webpack_public_path__ + "img/1525933414.c1245596.jpg";